import { getSearchParamsFromObject } from 'utils/url'

export const getSearchParamsWithSeparatorFromObject = (object: object) => {
  const searchParams = getSearchParamsFromObject(object)

  return `?${searchParams}`
}
